export default "__VITE_ASSET__FUBCKkXV__"